import { makeFetch } from './makeFetch';
import { FetchArgs } from './types';

export const fetchInCorsMode = <T>(method: string, args: FetchArgs) => {
  const expectedArgsListLength = 5;
  const defaultArgs = new Array(expectedArgsListLength - args.length);

  defaultArgs[defaultArgs.length - 1] = 'cors';

  const argsList = [...args, ...defaultArgs];

  return makeFetch<T>(method, argsList as FetchArgs);
};
